import React, { useEffect, useRef } from "react";
import styled from "styled-components";

const CanvasWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  pointer-events: none;
  z-index: 4;
`;

const ScopeCanvas = () => {
  const canvasRef = useRef(null);

  const drawCutout = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const { width, height } = canvas;

    // Canvasのクリア
    ctx.clearRect(0, 0, width, height);

    // 背景を黒で塗りつぶし
    ctx.fillStyle = "black";
    ctx.fillRect(0, 0, width, height);

    const cutoutRadiusPercent=0.35;
    const blurWidthPercent = 5; // 外周ぼかし幅（％）

    // 中心部分を透明にする
    const cutoutRadius = Math.min(width, height) * cutoutRadiusPercent; // 半径の計算
    const centerX = Math.round(width / 2)*1; // 中心X座標を丸める
    const centerY = Math.round(height / 2)*1; // 中心Y座標を丸める
    

    const blurStartRadius = cutoutRadius;
    const blurEndRadius =
      Math.min(width, height) * ((cutoutRadiusPercent + blurWidthPercent) / 100);

    // 外周のぼかしを作成
  const gradient = ctx.createRadialGradient(
    centerX,
    centerY,
    blurStartRadius, // ぼかし開始位置
    centerX,
    centerY,
    blurEndRadius // ぼかし終了位置
  );
  gradient.addColorStop(0, "rgba(0, 0, 0, 0)"); // ぼかしの開始: 不透明
  gradient.addColorStop(0.2, "rgb(65, 123, 232)"); // ぼかしの終了: 透明

  ctx.fillStyle = gradient;
    ctx.beginPath();
    ctx.arc(centerX, centerY, blurEndRadius, 0, Math.PI * 2); // 外周ぼかし範囲
    ctx.fill();

    ctx.globalCompositeOperation = "destination-out"; // 切り抜きの設定
    ctx.beginPath();
    ctx.arc(centerX, centerY, cutoutRadius, 0, Math.PI * 2); // 中心から円を描画
    ctx.fill();

   

    // 描画モードを元に戻す
    ctx.globalCompositeOperation = "source-over";

       // 十字を描画
    ctx.strokeStyle = "red"; // 十字の色を赤に設定
    ctx.beginPath();
    ctx.moveTo(centerX - 10, centerY);
    ctx.lineTo(centerX + 10, centerY);
    ctx.moveTo(centerX, centerY - 10);
    ctx.lineTo(centerX, centerY + 10);
    ctx.stroke();
  };

  const handleResize = () => {
    const canvas = canvasRef.current;
    if (canvas) {
      // ウィンドウサイズに合わせてCanvasのサイズを設定
      canvas.width = document.documentElement.clientWidth;
      canvas.height = document.documentElement.clientHeight; // スクロールバーの幅を除いた描画可能領域の高さ

      // Canvas中心を再計算して再描画
      drawCutout();
    }
  };

  useEffect(() => {
    handleResize(); // 初期描画
    window.addEventListener("resize", handleResize); // リサイズイベント

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <CanvasWrapper>
      <canvas ref={canvasRef} />
    </CanvasWrapper>
  );
};

export default ScopeCanvas;
